import React, { useContext } from 'react'
import { AppBar, Box, Switch, Toolbar, Typography, Zoom } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { ThemeContext } from '../../context/ThemeContext'
import { useAuth } from '../../context/Auth'
import { BrandLink } from './components/NavbarDrawer/components/BrandLink/BrandLink'
import { MenuIconButton } from './components/NavbarDrawer/components/MenuIconButton/MenuIconButton'
import WbSunnyOutlinedIcon from '@mui/icons-material/WbSunnyOutlined'
import Brightness3OutlinedIcon from '@mui/icons-material/Brightness3Outlined'
import { Help } from './components/Help/Help'

const useStyles = makeStyles(theme => ({
  appBar: {},
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  title: {
    flexGrow: 1,
  },
  navbar: {
    marginBottom: theme.spacing(1),
    flex: '0 1 auto',
  },
}))

export const Navbar: React.FC = () => {
  const { toggleTheme, darkState } = useContext(ThemeContext)
  const classes = useStyles()
  const auth = useAuth()

  return (
    <>
      {auth && auth.id && (
        <div className={classes.navbar}>
          <AppBar enableColorOnDark position="static" className={classes.appBar}>
            <Toolbar className={classes.toolbar}>
              <BrandLink />
              <Typography
                component="h1"
                variant="h6"
                color="inherit"
                noWrap
                className={classes.title}
              >
                {auth.username}
              </Typography>
              <Box display="flex" alignItems="center">
                <Zoom in={!darkState}>
                  <WbSunnyOutlinedIcon />
                </Zoom>
                <Switch color={'secondary'} checked={darkState} onChange={toggleTheme} />
                <Zoom in={darkState}>
                  <Brightness3OutlinedIcon />
                </Zoom>
              </Box>
              <Help />
              <MenuIconButton />
            </Toolbar>
          </AppBar>
        </div>
      )}
    </>
  )
}
